import React from 'react'
import { motion } from 'framer-motion'

export default function AnimatedText({ text, keyProp }) {

	const sentence = {
		hidden: { opacity: 0 },
		visible: {
			opacity: 1,
			transition: {
				duration: 0.1,
				delayChildren: 0.01,
				staggerChildren: 0.03, // Stagger animation for words
			},
		}
	}

	const character = {
		hidden: { opacity: 0 },
		visible: { opacity: 1, transition: { duration: 0 } },
	};

	return (
		<motion.p key={keyProp} className="animated-text" variants={sentence} initial="hidden" animate="visible">
			{text.split(" ").map((wordText, wordIndex) => (
				<span key={wordIndex} style={{ display: "inline-block", whiteSpace: "nowrap", marginRight: "0.25em" }}>
					{wordText.split("").map((char, charIndex) => (
						<motion.span key={charIndex} variants={character} style={{ display: "inline-block" }}>
							{char}
						</motion.span>
					))}
				</span>
			))}
		</motion.p>
	)
}